import * as React from 'react'
import { cn } from '@/shared/utils'

interface FormSectionProps {
  title: string
  description?: string
  className?: string
  children: React.ReactNode
}

export function FormSection({ title, description, className, children }: FormSectionProps) {
  return (
    <div className={cn('space-y-4', className)}>
      <div className="border-b border-earth-200 pb-2">
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        {description && (
          <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
        )}
      </div>
      {children}
    </div>
  )
}
